
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"168","height":"155","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M101.259 2.538c-16.153-1.533-30.03 9.862-34.89 24.834-2.192 6.748-2.605 13.777-2.009 20.766.548 6.45 3.804 15.33 1.848 21.676-4.32 14.013-31.725 9.9-42.942 11.882-10.328 1.823-12.957 11.752-10.29 19.748.167 3.932 2.061 7.844 6.06 10.406 28.47 18.253 67.73 24.59 95.779 1.059 23.447-19.671 27.083-55.945 16.797-83.277-5.099-13.552-15.007-25.635-30.351-27.09l-.002-.004z","fill":"#00BC70"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M55.35 73.977a4.569 4.569 0 003.85 2.118h14.384l-21.508 54.588c-.25 2.177.04 4.657 2.086 5.767.687.371 1.817.55 2.165.55a4.568 4.568 0 003.759-1.975l55.092-79.456c.974-1.605 1.092-3.445.303-4.968a4.573 4.573 0 00-4.059-2.48H97.255l10.906-24.627a4.645 4.645 0 00-.34-4.391 4.57 4.57 0 00-3.84-2.103H81.848c-1.901 0-3.53 1.055-4.274 2.7l-22.54 49.94c-.645 1.356-.527 3.017.316 4.337z","fill":"#F6E94A"}})])
          )
        }
      }
    